export enum EnumAuthentification{
    anonymous,
    windows
}